import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import Paso1Formulario from "./pages/Paso1Formulario";
import Paso2Factura from "./pages/Paso2Factura";
import Paso3Resultados from "./pages/Paso3Resultados";
import Paso3Semaforo from "./pages/Paso3Semaforo";
import Paso4Confirmacion from "./pages/Paso4Confirmacion";
import Panel from "./pages/Panel";
import logoNeron from "./assets/NeronEnergia_logo.png";
import fondoLogin from "./assets/fondologin.png";
import "./App.css";

// Pasos: 1=formulario, 2=factura, 3=semaforo, 4=ranking, 5=confirmacion, 6=enviado
function Comparador() {
  const [paso, setPaso] = useState(1);
  const [leadData, setLeadData] = useState(null);
  const [resultados, setResultados] = useState(null);
  const [cargando, setCargando] = useState(false);
  const [errorCarga, setErrorCarga] = useState("");

  const irAPaso2 = (datos) => { setLeadData(datos); setPaso(2); };
  const irAPaso3 = (data) => { setResultados(data); setCargando(false); setErrorCarga(""); setPaso(3); };
  const irARanking = () => { setPaso(4); };
  const irAPaso5 = () => { setPaso(5); };
  const onSolicitudEnviada = () => { setPasoStepper(6); };
  const onError = (msg) => { setErrorCarga(msg); setCargando(false); };
  const cerrarError = () => { setErrorCarga(""); };

  const reiniciar = () => {
    setPaso(1);
    setLeadData(null);
    setResultados(null);
    setCargando(false);
    setErrorCarga("");
    setPasoStepper(null);
  };

  const [pasoStepperExtra, setPasoStepper] = useState(null);
  const STEP_LABELS = ["Tus datos", "Tu factura", "Salud energética", "Resultados", "Confirmación"];
  const pasoStepper = pasoStepperExtra || (paso === 3 ? 3 : paso === 4 ? 4 : paso >= 5 ? 5 : paso);

  return (
    <div className="app-wrapper">
      <header className="app-header">
        <img src={logoNeron} alt="Nerón Energía" className="header-logo" />
        <div className="header-brand">
          <span className="brand-name">Nerón <span className="brand-accent">Energía</span></span>
          <span className="brand-sub">Comparador de tarifas</span>
        </div>
        <div className="header-status">
          <span className="status-dot"></span>
          <span className="status-text">En línea</span>
        </div>
      </header>

      {!cargando && !errorCarga && (
        <div className="stepper">
          {[1, 2, 3, 4, 5].map((n) => (
            <div key={n} className={`step ${pasoStepper === n ? "active" : pasoStepper > n ? "done" : ""}`}>
              <div className="step-circle">{pasoStepper > n ? "✓" : n}</div>
              <span className="step-label">{STEP_LABELS[n - 1]}</span>
              {n < 5 && <div className={`step-line ${pasoStepper > n ? "done" : ""}`} />}
            </div>
          ))}
        </div>
      )}

      {cargando && !errorCarga && (
        <div className="loading-screen">
          <div className="loading-spinner-wrapper">
            <div className="loading-ring"></div>
            <img src={logoNeron} alt="Cargando..." className="loading-logo" />
          </div>
          <p className="loading-text">Analizando tu factura...</p>
          <p className="loading-sub">Comparando con todas las tarifas disponibles</p>
        </div>
      )}

      {errorCarga && (
        <div className="loading-screen">
          <div style={{ fontSize: 48, marginBottom: 8 }}>⚠️</div>
          <p className="loading-text" style={{ color: "var(--red)" }}>No hemos podido procesar la factura</p>
          <div style={{
            background: "rgba(255,91,91,.08)", border: "1px solid rgba(255,91,91,.3)",
            borderRadius: 10, padding: "16px 24px", maxWidth: 460, textAlign: "center",
          }}>
            <p style={{ color: "var(--red)", fontSize: 14, lineHeight: 1.7 }}>{errorCarga}</p>
          </div>
          <button className="btn btn-primary" onClick={cerrarError} style={{ marginTop: 8 }}>
            ← Volver e intentarlo de nuevo
          </button>
        </div>
      )}

      <main className="app-main" style={{
        display: (cargando || errorCarga) ? "none" : "block",
        backgroundImage: `url(${fondoLogin})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}>
        {paso === 1 && <Paso1Formulario onSiguiente={irAPaso2} />}
        {paso === 2 && (
          <Paso2Factura
            leadData={leadData}
            onResultados={irAPaso3}
            onError={onError}
            setCargando={setCargando}
            onReiniciar={reiniciar}
          />
        )}
        {paso === 3 && (
          <Paso3Semaforo resultados={resultados} onSiguiente={irARanking} />
        )}
        {paso === 4 && (
          <Paso3Resultados
            resultados={resultados}
            leadData={leadData}
            onReiniciar={reiniciar}
            onSeleccionarTarifa={irAPaso5}
          />
        )}
        {paso === 5 && (
          <Paso4Confirmacion leadData={leadData} resultados={resultados} onReiniciar={reiniciar} onConfirmar={onSolicitudEnviada} />
        )}
      </main>

      <footer className="app-footer" style={{ display: (cargando || errorCarga) ? "none" : "block" }}>
        <span>© 2025 Nerón Energía · Comparador orientativo</span>
      </footer>
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/panel" element={<Panel />} />
      <Route path="/*" element={<Comparador />} />
    </Routes>
  );
}
